import axios from "./Axios";

export default axios;
